(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
// JavaScript-based marquee that never stops on mobile
class RobustMarquee {
  constructor(element) {
    this.element = element;
    this.track = element.querySelector('[data-marquee-track]');
    this.originalContent = element.querySelector('.marquee-original-content');
    this.clonedContent = element.querySelector('.marquee-cloned-content');
    this.speed = parseInt(element.dataset.speed) || 50; // pixels per second
    this.direction = element.dataset.movementDirection === 'reverse' ? 1 : -1;
    this.isPlaying = true;
    this.animationId = null;
    this.position = 0;
    this.contentWidth = 0;
    this.cloneCount = 0;
    
    this.init();
  }

  init() {
    // Clone content for seamless loop
    this.cloneContent();
    
    // Calculate content width
    this.calculateDimensions();
    
    // Start animation
    this.animate();
    
    // Handle resize
    window.addEventListener('resize', () => this.calculateDimensions());
    
    // Handle visibility change (tab switch)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.play();
      }
    });
    
    // Mobile touch events - DO NOT STOP animation
    this.track.addEventListener('touchstart', (e) => {
      // Continue animation regardless of touch
      this.play();
      e.stopPropagation();
    }, { passive: true });

    this.track.addEventListener('touchmove', (e) => {
      // Animation continues during touch move
      e.stopPropagation();
    }, { passive: true });

    // Disable any hover effects on mobile
    if ('ontouchstart' in window) {
      this.track.style.pointerEvents = 'none';
      this.track.style.userSelect = 'none';
      this.track.style.webkitUserSelect = 'none';
    }
  }

  cloneContent() {
    if (!this.originalContent || !this.clonedContent) return;
    
    // Clear cloned content
    this.clonedContent.innerHTML = '';
    
    // Clone multiple times to ensure seamless loop
    const originalHTML = this.originalContent.innerHTML;
    
    // Clone enough times to cover at least 3x viewport
    for (let i = 0; i < 3; i++) {
      const clone = document.createElement('div');
      clone.innerHTML = originalHTML;
      clone.style.display = 'flex';
      clone.style.gap = 'var(--marquee-gap)';
      clone.style.alignItems = 'center';
      this.clonedContent.appendChild(clone);
    }
    
    this.cloneCount = 3;
  }

  calculateDimensions() {
    if (!this.originalContent) return;
    
    // Get width of original content
    const originalRect = this.originalContent.getBoundingClientRect();
    this.contentWidth = originalRect.width + parseInt(getComputedStyle(this.originalContent).gap || 0);
    
    // Adjust track width
    if (this.track) {
      this.track.style.width = `${this.contentWidth * (this.cloneCount + 1)}px`;
    }
  }

  animate() {
    const animateFrame = () => {
      if (!this.isPlaying) return;
      
      // Calculate movement based on speed (pixels per second)
      const delta = (this.speed * this.direction) / 60; // Assuming 60fps
      this.position += delta;
      
      // Reset position when content moves completely
      const resetThreshold = this.contentWidth;
      if (Math.abs(this.position) >= resetThreshold) {
        this.position %= resetThreshold;
      }
      
      // Apply transform
      if (this.track) {
        this.track.style.transform = `translateX(${this.position}px)`;
        this.track.style.transition = 'none'; // No CSS transition
      }
      
      this.animationId = requestAnimationFrame(animateFrame);
    };
    
    this.animationId = requestAnimationFrame(animateFrame);
  }

  play() {
    if (this.isPlaying) return;
    this.isPlaying = true;
    this.animate();
  }

  stop() {
    this.isPlaying = false;
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }

  destroy() {
    this.stop();
    window.removeEventListener('resize', () => this.calculateDimensions());
  }
}

// Initialize all marquees
document.addEventListener('DOMContentLoaded', () => {
  const marqueeElements = document.querySelectorAll('marquee-component[data-scroll-fix="true"]');
  
  marqueeElements.forEach(element => {
    // Remove any existing CSS animations
    const track = element.querySelector('[data-marquee-track]');
    if (track) {
      track.style.animation = 'none';
      track.style.animationPlayState = 'running';
    }
    
    // Initialize JavaScript marquee
    new RobustMarquee(element);
  });
  
  // Re-initialize when Shopify editor reloads sections
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', (event) => {
      const newMarquee = event.target.querySelector('marquee-component[data-scroll-fix="true"]');
      if (newMarquee) {
        setTimeout(() => {
          new RobustMarquee(newMarquee);
        }, 100);
      }
    });
  }
});

// Alternative simple solution if above doesn't work
class SimpleMarqueeFix {
  constructor() {
    this.fixAllMarquees();
    this.bindEvents();
  }

  fixAllMarquees() {
    // Find all marquee wrappers with CSS animations
    const marqueeWrappers = document.querySelectorAll('.marquee__wrapper, [class*="marquee"]');
    
    marqueeWrappers.forEach(wrapper => {
      // Force animation to never pause
      wrapper.style.animationPlayState = 'running';
      wrapper.style.webkitAnimationPlayState = 'running';
      
      // Completely disable user interaction on mobile
      if ('ontouchstart' in window) {
        wrapper.style.pointerEvents = 'none';
        wrapper.style.touchAction = 'none';
        wrapper.style.webkitUserSelect = 'none';
        wrapper.style.userSelect = 'none';
        
        // Clone and restart animation periodically to prevent iOS from stopping it
        setInterval(() => {
          const animation = wrapper.style.animation;
          wrapper.style.animation = 'none';
          void wrapper.offsetWidth; // Trigger reflow
          wrapper.style.animation = animation;
          wrapper.style.animationPlayState = 'running';
        }, 3000); // Reset every 3 seconds
      }
    });
  }

  bindEvents() {
    // Prevent any touch/scroll events from affecting marquee
    document.addEventListener('touchstart', (e) => {
      const isMarquee = e.target.closest('.marquee__wrapper, [class*="marquee"], marquee-component');
      if (isMarquee) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });

    // Reset animation on scroll
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      
      const marqueeWrappers = document.querySelectorAll('.marquee__wrapper');
      marqueeWrappers.forEach(wrapper => {
        wrapper.style.animationPlayState = 'running';
        wrapper.style.webkitAnimationPlayState = 'running';
      });
      
      scrollTimeout = setTimeout(() => {
        marqueeWrappers.forEach(wrapper => {
          wrapper.style.animationPlayState = 'running';
          wrapper.style.webkitAnimationPlayState = 'running';
        });
      }, 100);
    }, { passive: true });
  }
}

// Initialize the simple fix as fallback
document.addEventListener('DOMContentLoaded', () => {
  new SimpleMarqueeFix();
});

  } catch(e) { console.error(e); }
})();
})();
